import styled from 'styled-components'
import { theme } from 'fpay-ui'

export const StyledFilter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 55px;
  border-radius: 4px;
  border: solid 1px #caced8;
  margin-top: 16px;
  ${theme.breakpoint('md')} {
    height: 47px;
    min-width: 312px;
    width: auto;
  }
  @media (min-width: 769px) {
    margin-top: 0px;
    min-width: 300px;
  }
`

export const SyledDateContainer = styled.div`
  display: flex;
  min-width: 200px;
  cursor: pointer;
  margin-left: 8px;
  margin-right: 8px;
  justify-content: space-between;
  width: 100%;
  opacity: ${props => (props.disabled ? '0.6' : '1')};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`

export const IconButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  & svg {
    vertical-align: middle;
  }
`

export const StyledDateFilter = styled.div`
  width: 100%;
  font-size: 14px;
  ${({ theme }) => theme.newBreakpoint('sm')} {
    font-size: 14px;
  }
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  padding-left: 16px;
  padding-right: 16px;
`

export const StyledDatePicker = styled.div`
  min-height: 36px;
  #btn-drop-down-calendar {
    display: none;
  }

  > div:first-child {
    ::before {
      display: none;
      ${({ theme }) => theme.breakpoint(null, 'md')} {
        display: ${({ show }) => (show ? 'unset' : 'none')};
      }
      content: '';
      background-color: #444b62;
      position: fixed;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      z-index: -1;
      opacity: 70%;
      transition: opacity 1s ease-out;
    }
    ${({ theme }) => theme.breakpoint('sm', 'md')} {
      > div {
        bottom: unset;
        border-radius: 5px;
        margin: 0px;
        > div:nth-child(4) {
          padding-top: 16px;
        }
      }
    }
  }
`
